"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { useState } from "react";

import { fetchJson } from "@/lib/api";

export default function PasswordResetClient() {
  const params = useSearchParams();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(params.get("token") ?? "");
  const [nextPassword, setNextPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function request() {
    setLoading(true);
    setMessage("");
    try {
      const data = await fetchJson<{ accepted: boolean; devToken: string | null }>("/api/auth/password-reset/request", { method: "POST", body: JSON.stringify({ email }) });
      if (data.devToken) setToken(data.devToken);
      setMessage("該当するアカウントがある場合、パスワード再設定の案内を送信しました。メールをご確認ください。");
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "再設定メールを送信できませんでした");
    } finally {
      setLoading(false);
    }
  }

  async function confirm() {
    setLoading(true);
    setMessage("");
    try {
      await fetchJson("/api/auth/password-reset/confirm", { method: "POST", body: JSON.stringify({ token, next_password: nextPassword, password_confirmation: confirmation }) });
      setMessage("パスワードを再設定しました。ログインしてください。");
      setNextPassword("");
      setConfirmation("");
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "パスワードを再設定できませんでした");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="mx-auto grid w-full max-w-xl gap-5">
      <section className="surface-panel rounded-md p-6">
        <div className="text-xs font-semibold uppercase text-[color:var(--muted)]">Tairoh</div>
        <h1 className="mt-1 text-2xl font-semibold">パスワードを再設定</h1>
        <p className="mt-2 text-sm text-[color:var(--muted)]">登録済みのメールアドレスへ、期限付きの再設定リンクを送信します。</p>
        <div className="mt-5 grid gap-2">
          <label className="grid gap-1 text-sm"><span>メールアドレス</span><input className="field-input rounded-md" type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
          <button type="button" className="button-secondary h-10 rounded-md px-4 text-sm font-semibold" disabled={loading || !email} onClick={() => void request()}>再設定メールを送信</button>
        </div>
      </section>
      <section className="surface-panel rounded-md p-6">
        <h2 className="text-lg font-semibold">新しいパスワード</h2>
        <div className="mt-4 grid gap-3">
          <label className="grid gap-1 text-sm"><span>再設定トークン</span><input className="field-input rounded-md font-mono text-xs" value={token} onChange={(event) => setToken(event.target.value)} placeholder="メールのリンクから自動入力" /></label>
          <label className="grid gap-1 text-sm"><span>新しいパスワード</span><input className="field-input rounded-md" type="password" autoComplete="new-password" value={nextPassword} onChange={(event) => setNextPassword(event.target.value)} /></label>
          <label className="grid gap-1 text-sm"><span>新しいパスワード（確認）</span><input className="field-input rounded-md" type="password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} /></label>
          <button type="button" className="button-primary h-10 rounded-md px-4 text-sm font-semibold" disabled={loading || !token || !nextPassword || !confirmation} onClick={() => void confirm()}>パスワードを更新</button>
        </div>
      </section>
      {message ? <p role="status" className="rounded-md border border-[color:var(--line)] bg-white p-3 text-sm">{message}</p> : null}
      <Link href="/login" className="text-center text-sm font-semibold text-[color:var(--accent-strong)]">ログイン画面へ戻る</Link>
    </main>
  );
}
